var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24336",
    "data-name": "Group 24336",
    transform: "translate(-472.501 -1176.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1510",
    "data-name": "Ellipse 1510",
    transform: "translate(472.501 1176.257)",
    fill: "#fff",
    stroke: "#4867aa",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_001-facebook",
    "data-name": "001-facebook",
    d: "M9.66,1.411h.776V.06A10.015,10.015,0,0,0,9.305,0C6.851,0,7.519,2.779,7.421,3.186H6.187V4.7H7.421V8.5H8.934V4.7h1.184l.188-1.51H8.934c.067-1-.269-1.776.726-1.776Z",
    transform: "translate(472.963 1181.191)",
    fill: "#4867aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_001-facebook-2",
    "data-name": "001-facebook",
    d: "M9.66,1.411h.776V.06A10.015,10.015,0,0,0,9.305,0C6.851,0,7.519,2.779,7.421,3.186H6.187V4.7H7.421V8.5H8.934V4.7h1.184l.188-1.51H8.934c.067-1-.269-1.776.726-1.776Z",
    transform: "translate(472.963 1180.934)",
    fill: "#4867aa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.110b9efa8b884084b64928378277944b.svg";
export { ForwardRef as ReactComponent };